import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { CustomHighlightModel } from '../../models/custom-highlight-model';
import { Emitter } from '@patsnap/tahiti-core/common/event';
import type { CustomHighlight } from '../../types';
import type { CustomHighlightService } from '../custom-highlight-service';

@injectable()
export class CustomHighlightServiceImpl implements CustomHighlightService {
    private _onStatesChangeEmitter = new Emitter<CustomHighlight>();
    readonly onStatesChange = this._onStatesChangeEmitter.event;

    constructor(
        @inject(CustomHighlightModel)
        private _model: CustomHighlightModel,
    ) {
        this._model.onStatesChange(this._emitModelDataChange.bind(this));
    }

    private _emitModelDataChange() {
        this._onStatesChangeEmitter.fire(this.getModelData());
    }

    public getModelData() {
        return this._model.modelData;
    }

    public updateEnable(isEnable: boolean) {
        this._model.update(() => ({ isEnable }));
    }
}
